import { ElementType } from 'react';
import { PayoutStatus } from '@frontend/api-payouts';
import { Chip, ChipVariants } from '@frontend/design-system';
import { prettify } from '../../../utils/date-helpers';

type PayoutStatusChipProps = {
  status: PayoutStatus;
  as?: ElementType;
};

const mapStatus = (status: PayoutStatus): ChipVariants => {
  switch (status) {
    case PayoutStatus.Paid:
      return 'success';
    case PayoutStatus.Canceled:
      return 'disabled';
    case PayoutStatus.Failed:
      return 'critical';
    case PayoutStatus.Pending:
      return 'primary';
    default:
      return 'primary';
  }
};

export const PayoutStatusChip = ({ status, as, ...rest }: PayoutStatusChipProps) => {
  return (
    status && (
      <Chip variant={mapStatus(status)} {...rest}>
        {prettify(status, { split: '_' })}
      </Chip>
    )
  );
};
